import React from 'react';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import {
  useConnectorUIState,
  useSourceUIState,
} from '../../../uiState/contexts';
import {
  CustomSourceProvider,
  SFTPSourceProvider,
  useAddConnector,
} from '../../../dataState';
import SourceCustomForm from './SourceCustomForm';
import { renderTheSteps } from './util/renderTheSteps';

const STEPS = [FirstStep, SecondStep];

const SFTPSource: React.FC = () => {
  const [{ index, repeatedSource, chosenSource }] = useConnectorUIState();
  const [data] = useAddConnector();
  const [{ step }] = useSourceUIState();
  const Component = STEPS[step];
  const initialData = data.sources?.[index];

  const renderSteps = renderTheSteps({
    chosenSource: Boolean(chosenSource),
    repeatedSource,
  });

  if (!renderSteps) {
    return null;
  }

  const {
    name: preconfiguredSourceName,
    provider,
    displayName,
    stableVersion,
    configuration,
  } = chosenSource!;

  if (chosenSource!.configuration) {
    return (
      <CustomSourceProvider
        initialState={{
          preconfiguredSourceName,
          provider,
          stableVersion,
          displayName,
          configuration,
          sftpType: undefined,
        }}
      >
        <SourceCustomForm />
      </CustomSourceProvider>
    );
  }

  return (
    <SFTPSourceProvider
      initialState={{
        preconfiguredSourceName,
        provider,
        stableVersion,
        displayName,
        sftpType: 'custom',
        ...initialData,
      }}
    >
      <Component />
    </SFTPSourceProvider>
  );
};

export default SFTPSource;
